__turbopack_context__.v({
  "bgAccent": "card-module-scss-module__mv4olG__bgAccent",
  "bgGradientAccent": "card-module-scss-module__mv4olG__bgGradientAccent",
  "bgGradientPrimary": "card-module-scss-module__mv4olG__bgGradientPrimary",
  "bgGradientSuccess": "card-module-scss-module__mv4olG__bgGradientSuccess",
  "borderAccent": "card-module-scss-module__mv4olG__borderAccent",
  "borderPrimary": "card-module-scss-module__mv4olG__borderPrimary",
  "borderSuccess": "card-module-scss-module__mv4olG__borderSuccess",
  "card": "card-module-scss-module__mv4olG__card",
  "cardContent": "card-module-scss-module__mv4olG__cardContent",
  "cardDescription": "card-module-scss-module__mv4olG__cardDescription",
  "cardFooter": "card-module-scss-module__mv4olG__cardFooter",
  "cardHeader": "card-module-scss-module__mv4olG__cardHeader",
  "cardTitle": "card-module-scss-module__mv4olG__cardTitle",
  "shadowElevated": "card-module-scss-module__mv4olG__shadowElevated",
  "shadowSmooth": "card-module-scss-module__mv4olG__shadowSmooth",
});
